module.exports = __webpack_public_path__ + "img/climbing-btn-icon.75147348.svg";